import { useNavigate } from 'react-router';
import { useModalContext } from 'src/hooks/useModalContext';
import { useRoute } from 'src/router/hooks/useRoute';
import { Button } from 'src/components/Buttons/Button';
import { WalletIcon } from 'src/svg/WalletIcon';
import { useGetUserBalanceInfo } from 'src/hooks/useGetUserBalanceInfo';
import { cioTrackEvent } from 'src/modules/cio';

export const DepositButton = () => {
  const { totalBalance } = useGetUserBalanceInfo();
  const { ROUTE } = useRoute();
  const navigate = useNavigate();
  const { openModal } = useModalContext();

  const handleDepositClick = () => {
    cioTrackEvent('deposit_btn_click', 'header');
    location.pathname.includes('account')
      ? navigate(ROUTE.ACCOUNT_DEPOSIT.get())
      : openModal('DEPOSIT');
  };

  return (
    <div
      onClick={handleDepositClick}
      className="flex flex-row items-center justify-center py-[1px] pl-3 pr-[1px] gap-2 cursor-pointer border rounded-[10px] border-hd_border bg-hd_backgroud">
      <p className="text-hd_text text-base font-semibold">{totalBalance}</p>
      <Button mode="button-deposit" className="w-9 !h-9 p-0">
        <WalletIcon />
      </Button>
    </div>
  );
};
